import React, { useEffect, useState } from "react";
import "../FormComponents/CoAuthor_M.css";
import Switch from "@mui/material/Switch";
import {
  Container,
  Row,
  Col,
  Dropdown,
  Button as B_Button,
} from "react-bootstrap";
import CachedIcon from "@mui/icons-material/Cached";
import {
  Button,
  IconButton,
  Typography,
  Modal,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import { Modal as B_Modal, Form } from "react-bootstrap";
import LanguageIcon from "@mui/icons-material/Language";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import AirplayIcon from "@mui/icons-material/Airplay";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import InputLabel from "@mui/material/InputLabel";
import FeedbackIcon from "@mui/icons-material/Feedback";
import MenuItem from "@mui/material/MenuItem";
import { TextField } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import SelectDropdownMui from "../../ReusableComponents/SelectDropdownMui";
import PlagiarismIcon from "@mui/icons-material/Plagiarism";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import MicIcon from "@mui/icons-material/Mic";
// import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";
import citationService from "../../../services/citationService";
import { v4 as uuidv4 } from "uuid";
import { CoAuthor_Searchcomponent } from "./CoAuthor_Search";
import { CoAuthor_Aireviewcomponent } from "./CoAuthor_Aireview";
import { Coauthor_Notescomponent } from "./CoAuthor_Notes";
import { Coauthor_Citationcomponent } from "./CoAuthor_Citation";
import PlagiarismOutlinedIcon from "@mui/icons-material/PlagiarismOutlined";
import CoAuther_PlagiarismChecker_Text from "./CoAuther_PlagiarismChecker_Text";
import CoAuther_PlagiarismChecker_addWords from "./CoAuther_PlagiarismChecker_addWords";
import CoAuther_PlagiarismChecker_Blank from "./CoAuther_PlagiarismChecker_Blank";
import aireviewicon from "../../../static/AI_Review_color.png";
import aireviewiconwhite from "../../../static/AI_Review_white.png";
import plagiarismicon from "../../../static/Plagiarism_logo.png";
import plagiarismiconwhite from "../../../static/Plagiarism_white.png";
import { getNotes } from "../../../services/notesService";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import {
  closeLeftNavbar,
  closeRightModal,
  closeRightModalAndOpenLeftNavbar,
  openLeftNavbar,
  openRightModal,
  openRightModalAndCloseLeftNavbar,
} from "../../../redux/handleSideNavBarAndModel/handleStatus.action";
import { fullSizeEditor } from "../../../redux/manageFullSizeEditor/fullSizeEditor.action";
import { checkFeatureAccess } from "../../featureAccess";
import plagiarismiconGray from "../../../static/Plagiarism 2.png";
import aireviewiconGray from "../../../static/AI Review Icon 1.png";
import { useCheckFeatureAccess } from "../../CheckFeature";
import { Box, Card, CardContent, Drawer, Stack } from "@mui/material";
import {
  CheckCircle,
  ChevronLeft,
  ChevronRight,
  ContentCopy,
  FormatQuote,
  Search,
  StickyNote2,
} from "@mui/icons-material";

const label = { inputProps: { "aria-label": "Switch demo" } };

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "blue",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const useStyles = makeStyles({
  icon: {
    color: "inherit",
    transition: "color 0.3s",
  },
});

// ToolCard Component
function ToolCard({ tool, onClick, accessEnabled = true }) {
  return (
    <div
      className="group relative cursor-pointer transition-all duration-200"
      style={{
        borderRadius: "8px",
        border: "1px solid #e0e0e0",
        padding: "12px 16px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
        backgroundColor: "#fff",
        opacity: accessEnabled ? 1 : 0.5,
        cursor: accessEnabled ? "pointer" : "not-allowed",
      }}
      onClick={accessEnabled ? onClick : undefined}
      onMouseEnter={(e) => {
        if (accessEnabled) {
          e.currentTarget.style.transform = "translateX(-4px)";
          e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
          e.currentTarget.style.backgroundColor = "#f9fafb";
        }
      }}
      onMouseLeave={(e) => {
        if (accessEnabled) {
          e.currentTarget.style.transform = "translateX(0)";
          e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
          e.currentTarget.style.backgroundColor = "#fff";
        }
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div
          style={{
            width: "36px",
            height: "36px",
            borderRadius: "8px",
            backgroundColor: `${tool.color}15`,
            color: accessEnabled ? tool.color : "#9ca3af",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {tool.icon}
        </div>
        <span
          style={{
            fontSize: "14px",
            fontWeight: 500,
            color: accessEnabled ? "#374151" : "#9ca3af",
          }}
        >
          {tool.label}
        </span>
      </div>
    </div>
  );
}

const CoauthorModal = (props) => {
  const classes = useStyles();
  const email = sessionStorage.getItem("currentUserEmail");
  const [showModal, setShowModal] = useState(false);
  const [showResearchContent, setShowResearchContent] = useState(true);
  const [showTextSnippetContent, setShowTextSnippetContent] = useState(false);
  const [showFormatQuoteContent, setShowFormatQuoteContent] = useState(false);
  const [showAireviewContent, setshowAireviewContent] = useState(false);
  const [noteInput, setNoteInput] = useState("");
  const [coAuther_PlagiarismChecker, setCoAuther_PlagiarismChecker] =
    useState(false);
  const [hoveredPC, setHoveredPC] = useState(false);
  const [hoveredAI, setHoveredAI] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const currentNavItem = useSelector(
    (state) => state.manageCoauthorNavReducer.currentCoauthorNavItem
  );
  const dispatch = useDispatch();
  const { rightModalOpen, leftNavbarOpen } = useSelector(
    (state) => state.handleModelAndSideBavBar
  );
  const { isFullSize } = useSelector((state) => state.manageFullSizeEditor);

  // Feature access checks
  const accessToSearch = useCheckFeatureAccess(currentNavItem, "search");
  const accessToCitation = useCheckFeatureAccess(currentNavItem, "citation");
  const accessToAiReview = useCheckFeatureAccess(currentNavItem, "AIReview");
  const accessToPlagiarism = useCheckFeatureAccess(
    currentNavItem,
    "plagiarism"
  );

  const sidebarTools = [
    {
      icon: <Search />,
      label: "Search",
      color: "#9c27b0",
      onClick: handleresarchContente,
      access: accessToSearch,
    },
    {
      icon: <StickyNote2 />,
      label: "Notes",
      color: "#ff6f00",
      onClick: handletextContente,
      access: true,
    },
    {
      icon: <FormatQuote />,
      label: "Citations",
      color: "#e91e63",
      onClick: handcitationContente,
      access: accessToCitation,
    },
    {
      icon: <CheckCircle />,
      label: "AI Review",
      color: "#4caf50",
      onClick: handleAireview,
      access: accessToAiReview,
    },
    {
      icon: <ContentCopy />,
      label: "Plagiarism",
      color: "#f44336",
      onClick: handlePlagiarismCheck,
      access: accessToPlagiarism,
    },
  ];

  function handletextContente() {
    setShowModal(true);
    setShowTextSnippetContent(true);
    setShowResearchContent(false);
    setShowFormatQuoteContent(false);
    setshowAireviewContent(false);
    setCoAuther_PlagiarismChecker(false);
    props.setTrackIsModalOpen(true);
    dispatch(openRightModalAndCloseLeftNavbar());
    setIsOpen(false); // Close drawer when opening modal
  }

  function handleresarchContente() {
    if (!accessToSearch) return;
    setShowModal(true);
    setShowTextSnippetContent(false);
    setShowResearchContent(true);
    setShowFormatQuoteContent(false);
    setshowAireviewContent(false);
    setCoAuther_PlagiarismChecker(false);
    props.setTrackIsModalOpen(true);
    dispatch(openRightModalAndCloseLeftNavbar());
    setIsOpen(false);
  }

  function handcitationContente() {
    if (!accessToCitation) return;
    setShowModal(true);
    setShowTextSnippetContent(false);
    setShowResearchContent(false);
    setShowFormatQuoteContent(true);
    setshowAireviewContent(false);
    setCoAuther_PlagiarismChecker(false);
    props.setTrackIsModalOpen(true);
    dispatch(openRightModalAndCloseLeftNavbar());
    setIsOpen(false);
  }

  function handleAireview() {
    if (!accessToAiReview) return;
    setShowModal(true);
    setshowAireviewContent(true);
    setShowTextSnippetContent(false);
    setShowResearchContent(false);
    setShowFormatQuoteContent(false);
    setCoAuther_PlagiarismChecker(false);
    props.setTrackIsModalOpen(true);
    dispatch(openRightModalAndCloseLeftNavbar());
    setIsOpen(false);
  }

  const handleCloseModal = () => {
    setShowModal(false);
    props.setTrackIsModalOpen(false);
    dispatch(
      props.mobileView ? closeRightModal() : closeRightModalAndOpenLeftNavbar()
    );
    if (isFullSize) {
      dispatch(fullSizeEditor());
      dispatch(closeLeftNavbar());
    }
  };

  function handlePlagiarismCheck() {
    if (!accessToPlagiarism) return;
    setShowModal(true);
    setShowTextSnippetContent(false);
    setShowResearchContent(false);
    setShowFormatQuoteContent(false);
    setshowAireviewContent(false);
    setCoAuther_PlagiarismChecker(true);
    props.setTrackIsModalOpen(true);
    dispatch(openRightModalAndCloseLeftNavbar());
    setIsOpen(false);
  }

  const handleTextInput = (text) => {
    setNoteInput(text);
  };

  const autherNameFromSearch = (name) => {
    props.passNametoCoNewProject(name);
  };

  const togglePanel = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        {/* Arc Toggle Sidebar */}
        <div className="relative">
          {/* Toggle Button - Arc Design with Arrow Inside */}
          {!props.mobileView && (
            <div
              style={{
                position: "fixed",
                right: isOpen ? "280px" : "0px",
                top: "50%",
                transform: "translateY(-50%)",
                transition: "right 0.3s ease-in-out",
                zIndex: 50,
              }}
            >
              <button
                onClick={togglePanel}
                style={{
                  width: "48px",
                  height: "80px",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                  borderRadius: "8px 0 0 8px",
                  boxShadow: "-2px 0 8px rgba(0, 0, 0, 0.15)",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s ease",
                  position: "relative",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.width = "52px";
                  e.currentTarget.style.boxShadow =
                    "-4px 0 12px rgba(102, 126, 234, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.width = "48px";
                  e.currentTarget.style.boxShadow =
                    "-2px 0 8px rgba(0, 0, 0, 0.15)";
                }}
              >
                {isOpen ? (
                  <ChevronRight style={{ color: "white", fontSize: 20 }} />
                ) : (
                  <ChevronLeft style={{ color: "white", fontSize: 20 }} />
                  
                )
                }
                 <span style={{ fontSize: 30 }}>🪄</span>
              </button>
            </div>
          )}

          {/* Main Drawer Panel */}
          <div
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              height: "100%",
              width: props.mobileView ? "100%" : "280px",
              backgroundColor: "#fff",
              transform: isOpen ? "translateX(0)" : "translateX(100%)",
              transition: "transform 0.3s ease-in-out",
              zIndex: 40,
              borderLeft: "1px solid #e0e0e0",
              boxShadow: isOpen ? "-2px 0 8px rgba(0, 0, 0, 0.1)" : "none",
            }}
          >
            {/* Panel Content */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                paddingTop: "80px",
              }}
            >
              {/* Header */}
              <div
                style={{ padding: "16px", borderBottom: "1px solid #e5e7eb" }}
              >
                <h3
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#000000ff",
                    letterSpacing: "0.05em",
                    textTransform: "uppercase",
                    margin: 0,
                  }}
                >
                  Quick Tools
                </h3>
              </div>

              {/* Tools List */}
              <div
                style={{
                  flex: 1,
                  overflowY: "auto",
                  padding: "16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {sidebarTools.map((tool, index) => (
                  <ToolCard
                    key={index}
                    tool={tool}
                    onClick={tool.onClick}
                    accessEnabled={tool.access}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Overlay */}
          {isOpen && !props.mobileView && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.2)",
                zIndex: 35,
                transition: "opacity 0.3s",
              }}
              onClick={togglePanel}
            />
          )}
        </div>

        {/* Original Modal Content */}
        {rightModalOpen && (
          <div
            style={{
              position: props.mobileView ? "fixed" : "absolute",
              top: props.mobileView && "90px" ,
              right: props.mobileView ? "5px" : "0px",
              width: props.mobileView ? "70%" : "468px",
              height: props.mobileView
                ? "calc(100vh - 100px)"
                : "calc(96vh - 67px)",
              zIndex: 1000,
              backgroundColor: props.isDarkMode ? "#1a1a1a" : "#fff",
              boxShadow: "-2px 0 8px rgba(0, 0, 0, 0.15)",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* Modern Header with Icon Tabs */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 16px",
                backgroundColor: props.isDarkMode ? "#2a2a2a" : "#fff",
                borderBottom: `1px solid ${props.isDarkMode ? "#374151" : "#e5e7eb"}`,
                flexShrink: 0,
              }}
            >
              {/* Tool Icons */}
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  alignItems: "center",
                  flexWrap: props.mobileView ? "wrap" : "nowrap",
                }}
              >
                {/* Search Icon */}
                <LightTooltip title="Search">
                  <div
                    onClick={() => accessToSearch && handleresarchContente()}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      cursor: accessToSearch ? "pointer" : "not-allowed",
                      backgroundColor: showResearchContent
                        ? "#9c27b0"
                        : "transparent",
                      color: showResearchContent
                        ? "#fff"
                        : accessToSearch
                        ? "#9c27b0"
                        : "#9ca3af",
                      transition: "all 0.3s ease",
                      border: showResearchContent
                        ? "none"
                        : `2px solid ${props.isDarkMode ? "#374151" : "#e5e7eb"}`,
                      opacity: accessToSearch ? 1 : 0.5,
                    }}
                    onMouseEnter={(e) => {
                      if (accessToSearch && !showResearchContent) {
                        e.currentTarget.style.backgroundColor = props.isDarkMode
                          ? "#374151"
                          : "#f3f4f6";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!showResearchContent) {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    <Search style={{ fontSize: "20px" }} />
                    {showResearchContent && !props.mobileView && (
                      <span style={{ fontSize: "13px", fontWeight: 600 }}>
                        Search
                      </span>
                    )}
                  </div>
                </LightTooltip>

                {/* Notes Icon */}
                <LightTooltip title="Notes">
                  <div
                    onClick={handletextContente}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      backgroundColor: showTextSnippetContent
                        ? "#ff6f00"
                        : "transparent",
                      color: showTextSnippetContent ? "#fff" : "#ff6f00",
                      transition: "all 0.3s ease",
                      border: showTextSnippetContent
                        ? "none"
                        : `2px solid ${props.isDarkMode ? "#374151" : "#e5e7eb"}`,
                    }}
                    onMouseEnter={(e) => {
                      if (!showTextSnippetContent) {
                        e.currentTarget.style.backgroundColor = props.isDarkMode
                          ? "#374151"
                          : "#f3f4f6";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!showTextSnippetContent) {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    <StickyNote2 style={{ fontSize: "20px" }} />
                    {showTextSnippetContent && !props.mobileView && (
                      <span style={{ fontSize: "13px", fontWeight: 600 }}>
                        Notes
                      </span>
                    )}
                  </div>
                </LightTooltip>

                {/* Citation Icon */}
                <LightTooltip title="Citations">
                  <div
                    onClick={() => accessToCitation && handcitationContente()}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      cursor: accessToCitation ? "pointer" : "not-allowed",
                      backgroundColor: showFormatQuoteContent
                        ? "#e91e63"
                        : "transparent",
                      color: showFormatQuoteContent
                        ? "#fff"
                        : accessToCitation
                        ? "#e91e63"
                        : "#9ca3af",
                      transition: "all 0.3s ease",
                      border: showFormatQuoteContent
                        ? "none"
                        : `2px solid ${props.isDarkMode ? "#374151" : "#e5e7eb"}`,
                      opacity: accessToCitation ? 1 : 0.5,
                    }}
                    onMouseEnter={(e) => {
                      if (accessToCitation && !showFormatQuoteContent) {
                        e.currentTarget.style.backgroundColor = props.isDarkMode
                          ? "#374151"
                          : "#f3f4f6";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!showFormatQuoteContent) {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    <FormatQuote style={{ fontSize: "20px" }} />
                    {showFormatQuoteContent && !props.mobileView && (
                      <span style={{ fontSize: "13px", fontWeight: 600 }}>
                        Citations
                      </span>
                    )}
                  </div>
                </LightTooltip>

                {/* AI Review Icon */}
                <LightTooltip title="AI Review">
                  <div
                    onClick={() => accessToAiReview && handleAireview()}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      cursor: accessToAiReview ? "pointer" : "not-allowed",
                      backgroundColor: showAireviewContent
                        ? "#4caf50"
                        : "transparent",
                      color: showAireviewContent
                        ? "#fff"
                        : accessToAiReview
                        ? "#4caf50"
                        : "#9ca3af",
                      transition: "all 0.3s ease",
                      border: showAireviewContent
                        ? "none"
                        : `2px solid ${props.isDarkMode ? "#374151" : "#e5e7eb"}`,
                      opacity: accessToAiReview ? 1 : 0.5,
                    }}
                    onMouseEnter={(e) => {
                      if (accessToAiReview && !showAireviewContent) {
                        e.currentTarget.style.backgroundColor = props.isDarkMode
                          ? "#374151"
                          : "#f3f4f6";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!showAireviewContent) {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    <CheckCircle style={{ fontSize: "20px" }} />
                    {showAireviewContent && !props.mobileView && (
                      <span style={{ fontSize: "13px", fontWeight: 600 }}>
                        AI Review
                      </span>
                    )}
                  </div>
                </LightTooltip>

                {/* Plagiarism Icon */}
                <LightTooltip title="Plagiarism">
                  <div
                    onClick={() =>
                      accessToPlagiarism && handlePlagiarismCheck()
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      cursor: accessToPlagiarism ? "pointer" : "not-allowed",
                      backgroundColor: coAuther_PlagiarismChecker
                        ? "#f44336"
                        : "transparent",
                      color: coAuther_PlagiarismChecker
                        ? "#fff"
                        : accessToPlagiarism
                        ? "#f44336"
                        : "#9ca3af",
                      transition: "all 0.3s ease",
                      border: coAuther_PlagiarismChecker
                        ? "none"
                        : `2px solid ${props.isDarkMode ? "#374151" : "#e5e7eb"}`,
                      opacity: accessToPlagiarism ? 1 : 0.5,
                    }}
                    onMouseEnter={(e) => {
                      if (accessToPlagiarism && !coAuther_PlagiarismChecker) {
                        e.currentTarget.style.backgroundColor = props.isDarkMode
                          ? "#374151"
                          : "#f3f4f6";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!coAuther_PlagiarismChecker) {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    <ContentCopy style={{ fontSize: "20px" }} />
                    {coAuther_PlagiarismChecker && !props.mobileView && (
                      <span style={{ fontSize: "13px", fontWeight: 600 }}>
                        Plagiarism
                      </span>
                    )}
                  </div>
                </LightTooltip>
              </div>

              {/* Close Button */}
              <IconButton
                onClick={handleCloseModal}
                style={{
                  padding: "8px",
                  backgroundColor: props.isDarkMode ? "#374151" : "#f3f4f6",
                  borderRadius: "8px",
                }}
                size="small"
              >
                <CloseIcon
                  style={{
                    fontSize: "20px",
                    color: props.isDarkMode ? "#fff" : "#6b7280",
                  }}
                />
              </IconButton>
            </div>

            {/* Scrollable Content Area */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                overflowX: "hidden",
                backgroundColor: props.isDarkMode ? "#1a1a1a" : "#fff",
                padding: "0px",
              }}
            >
              {/* Content Sections */}
              {coAuther_PlagiarismChecker && props.count === 0 && (
                <CoAuther_PlagiarismChecker_Blank
                  handleModal={props.handleModal}
                  close={handleCloseModal}
                />
              )}
              {coAuther_PlagiarismChecker && props.count === 1 && (
                <CoAuther_PlagiarismChecker_addWords
                  handleModal={props.handleModal}
                  close={handleCloseModal}
                />
              )}
              {coAuther_PlagiarismChecker && props.count > 1 && (
                <CoAuther_PlagiarismChecker_Text
                  handleModal={props.handleModal}
                  editorState={props.state}
                  state={props.state}
                  setEditorState={props.setState}
                  mobileView={props.mobileView}
                  editorValue={props.editorValue}
                />
              )}

              {showResearchContent && (
                <CoAuthor_Searchcomponent
                  handleModal={props.handleModal}
                  autherName={autherNameFromSearch}
                  trial={props.trial}
                  userId={props.userId}
                  mobileView={props.mobileView}
                />
              )}

              {showTextSnippetContent && (
                <Coauthor_Notescomponent
                  handleModal={props.handleModal}
                  noteInput={noteInput}
                  handleTextInput={handleTextInput}
                />
              )}

              {showFormatQuoteContent && (
                <Coauthor_Citationcomponent
                  handleModal={props.handleModal}
                  trial={props.trial}
                  userId={props.userId}
                  mobileView={props.mobileView}
                />
              )}

              {showAireviewContent && (
                <CoAuthor_Aireviewcomponent
                  handleModal={props.handleModal}
                  editorState={props.state}
                  count={props.count}
                  selectedText={props.selectedEditorText}
                  selectedWordCount={props.wordCount}
                  trial={props.trial}
                  userId={props.userId}
                  mobileView={props.mobileView}
                  editorValue={props.editorValue}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CoauthorModal;
